import semver from 'semver';

// Each snippet is a real TS file so that `tsc` validates it against the matching package version.
// Vite inlines the raw source text here, so the snippet code itself is never bundled.
const snippetModules = import.meta.glob<string>(['./*.ts', '!./index.ts'], {
  query: '?raw',
  import: 'default',
  eager: true,
});

// Snippets import from version-aliased package names, show the real published name instead
const toPublishedPackageName = (code: string) =>
  code.replace(/@aginnovationaustralia\/emissions-calculators[\d.]+/g, '@aginnovationaustralia/emissions-calculators');

const snippets = Object.entries(snippetModules)
  .map(([path, code]) => ({
    version: path.replace(/^\.\/(.*)\.ts$/, '$1'),
    code: toPublishedPackageName(code),
  }))
  .sort((a, b) => semver.rcompare(a.version, b.version));

// Use the newest snippet that is not newer than the requested version, falling back to the oldest snippet
export function getExampleSnippet(version: string): string {
  const match = snippets.find((s) => semver.lte(s.version, version)) ?? snippets[snippets.length - 1];
  return match.code;
}
